export default [
  {
    path: '/operations/confirmation-tracking',
    name: 'confirmation-tracking',
    component: () => import('../pages/operations/confirmation-tracking/confirmation-tracking.shell.vue'),
  },
  {
    path: '/operations/changes-cancellations',
    name: 'changes-cancellations',
    component: () => import('../pages/operations/changes-cancellations/changes-cancellations.shell.vue'),
  },
];
